import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { RegisterPage } from "../pages/RegisterPage";

export const Route = createFileRoute("/register")({
  head: () => ({
    meta: [{ title: "Ro‘yxatdan o‘tish — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: Register,
});

function Register() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <RegisterPage />
    </LangProvider>
  );
}
